import { atom } from "recoil";
import { PathPickProductCardViewSettings } from "@/features/pathpick/types";
import { DEFAULT_PATH_PICK_PRODUCT_CARD_VIEW } from "@/features/pathpick/constants";

/**
 * 패스픽 상품 카드 보기 설정(KREAM·POIZON 비교 표시 / 좌우·상하 배치).
 *
 * localStorage에 영속되지만 atom을 단일 출처로 둔다. useLocalStorageState는 훅 인스턴스마다
 * state를 따로 들기 때문에, 설정 모달(헤더)에서 바꾼 값이 같은 화면의 카드 그리드에 닿지 않는다
 * — 담은 상품은 헤더와 그리드가 형제라 부모로 끌어올려도 prop이 여러 단을 지나야 한다.
 *
 * 읽기/쓰기는 usePathPickProductCardView 로만 한다(복원·정규화·저장이 그 안에 있다).
 */
export const pathPickProductCardViewState = atom<PathPickProductCardViewSettings>(
  {
    key: "PathPickProductCardView",
    default: DEFAULT_PATH_PICK_PRODUCT_CARD_VIEW,
  }
);
